import { Box, Checkbox, Stack, Text } from '@chakra-ui/core';
import React, { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useSeekersFilters } from '../filters/SeekersFiltersContext';
import { SearchAndSortTypes, WorkBrightStatusEnum } from '../filters/seekersFiltersContextValueType';

type SearchProps = {
  tempSearchAndSortType: SearchAndSortTypes;
  setTempSearchAndSortTypes: React.Dispatch<React.SetStateAction<SearchAndSortTypes>>;
};

export const WorkBrightStatus = ({ tempSearchAndSortType, setTempSearchAndSortTypes }: SearchProps): JSX.Element => {
  const { t } = useTranslation('i9Verification');

  const { setIsFromSearchAndSort } = useSeekersFilters();

  const onHandleI9Check = (searchAndSort: SearchAndSortTypes) => {
    setIsFromSearchAndSort(true);
    setTempSearchAndSortTypes({ ...searchAndSort });
  };

  return (
    <Box>
      <Stack direction="column">
        {Object.values(WorkBrightStatusEnum).map((value) => (
          <Checkbox
            data-testid={`workbrightStatus_${value}`}
            key={value}
            isChecked={tempSearchAndSortType.workbrightStatus.includes(value)}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              let updated: typeof tempSearchAndSortType.workbrightStatus;
              // istanbul ignore next
              if (e.target.checked) {
                if (!tempSearchAndSortType.workbrightStatus.includes(value)) {
                  updated = [...tempSearchAndSortType.workbrightStatus, value];
                } else {
                  updated = [...tempSearchAndSortType.workbrightStatus];
                }
              } else {
                updated = tempSearchAndSortType.workbrightStatus.filter((v) => v !== value);
              }
              onHandleI9Check({ ...tempSearchAndSortType, workbrightStatus: updated });
            }}
            // onChange={(e: ChangeEvent<HTMLInputElement>) => {
            //   const updated = [...tempSearchAndSortType.workbrightStatus];

            //   if (e.target.checked) {
            //     if (!updated.includes(value)) updated.push(value);
            //   } else {
            //     const idx = updated.indexOf(value);
            //     if (idx > -1) updated.splice(idx, 1);
            //   }
            //   onHandleI9Check({ ...tempSearchAndSortType, workbrightStatus: updated });
            // }}
          >
            <Text px={3} fontSize="14px">
              {t(`statusFilter.${value}`)}
            </Text>
          </Checkbox>
        ))}
      </Stack>
    </Box>
  );
};
